import { Typo } from "../Typo";

type RadioProps = {
  label: string;
  value: string;
  checked?: boolean;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
};

export const Radio = ({
  label,
  value,
  checked,
  onChange,
  error,
  disabled,
}: RadioProps) => {
  return (
    <label
      htmlFor={`radio-${value}`}
      className={`${disabled ? "cursor-not-allowed opacity-50" : ""} relative flex h-16 items-center rounded-2xl bg-[#f7f8f9] p-4 ${checked ? "border-border-stroke-primary border-2" : ""}`}
    >
      <Typo classes="w-full" element="span" type="labelSM">
        {label}
      </Typo>
      <input
        disabled={disabled}
        id={`radio-${value}`}
        type="radio"
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        name={`radio-${value}`}
        className={`peer min-h-6 min-w-6 cursor-pointer appearance-none rounded-full border bg-white transition-all checked:border-icon-primary checked:bg-icon-primary ${error ? "border-2 border-red-500" : "border-[#03142E33] bg-white"} `}
      />
      <span
        className="absolute top-1/2 h-3 w-3 -translate-x-1/2 -translate-y-1/2 transform rounded-full bg-white opacity-0 transition-opacity duration-200 peer-checked:opacity-100"
        style={{ left: "calc(100% - 28px)" }}
      />
    </label>
  );
};
